export var NOTIFICATION_FPN_SOURCE = 'notificationFullPage';
export var NOTIFICATION_COMPONENT = 'notificationFullPage';
export var REQUEST_REGISTRATION_NAME = 'cross-flow-product-request';
export var REQUEST_REGISTRATION_OWNER = 'Multipliers';
export var REQUEST_REGISTRATION_PRODUCT = 'cross-flow';
export var DES_REGISTRATION_NAME = 'cross-flow-des-notification';
export var DES_REGISTRATION_OWNER = 'Multipliers';
export var DES_REGISTRATION_PRODUCT = 'cross-flow';